import {
  ReviewsAPIResponse,
  TBlogPost,
  TBlogPostResult,
  TFAQList,
  TReviews,
} from './cms-types'
import { slimDocument, slimSlices } from './cms-helpers'
import dayjs from 'dayjs'
import { BuildQueryURLArgs, Client, predicate } from '@prismicio/client'
import { PrismicDocument, Query } from '@prismicio/types'
import fetch from 'node-fetch'
import { Utils } from './utils'

export const transformBlogPost = function (post: TBlogPost) {
  const res: TBlogPost = {
    ...post,
    data: {
      ...post.data,
      modified_date_iso: post.last_publication_date,
      published_date: post.data.published_date? dayjs(post.data.published_date).format('DD MMMM, YYYY'): null,
      published_date_iso: post.first_publication_date,
    },
  }
  return res
}

export const transformBlogPostResult = function (post: TBlogPost) {
  const res: TBlogPostResult = slimDocument({
    ...post,
    data: {
      body_excerpt: post.data.body_excerpt,
      main_image: post.data.main_image,
      modified_date: dayjs(post.data.published_date).format('DD MMMM, YYYY'),
      title: post.data.title,
    },
  })
  return res
}

export const getPosts = (
  client: Client<PrismicDocument>,
  page = 1,
  lang: string,
  pageSize: number,
  existingPosts?: Query<TBlogPostResult>,
  tag?: string,
  search?: string,
) => {
  const params: Partial<BuildQueryURLArgs> = {
    lang,
    orderings: 'my.blog_post.published_date desc',
    page,
    pageSize,
    predicates: search
      ? [predicate.fulltext('my.blog_post.body', search)]
      : undefined,
  }
  return (
    tag
      ? client.getByTag(tag, params)
      : client.getByType<TBlogPost>('blog_post', params)
  ).then((res) => {
    return {
      ...res,
      results: (existingPosts?.results || []).concat(
        res.results.map((post) => {
          return transformBlogPostResult(post as TBlogPost)
        }),
      ),
    }
  })
}

export const getTags = (client: Client<PrismicDocument>, lang: string) => {
  return client.getTags({}).then((res) => {
    return res
  })
}

export const getFAQList = (
  client: Client<PrismicDocument>,
  lang: string,
  uid: string,
) => {
  return client.getByUID<TFAQList>('faq_list', uid).then((res) => {
    return slimDocument({
      ...res,
      data: {
        ...res.data,
        slices: slimSlices(res.data.slices as any),
      },
    })
  })
}

export const getReviews = async () => {
  const url = `https://api.reviews.io/reviews?store=hoxton-mix&minRating=4&per_page=6&page=1&include_product_reviews=true&include_local_reviews=true&apikey=${process.env.REVIEWS_API_KEY}`

  const res: ReviewsAPIResponse = await fetch(url).then((res) => res.json())
  const worstToBest = Object.keys(res.stats.ratings).sort(
    (a, b) => parseInt(a) - parseInt(b),
  )
  return {
    average: parseFloat(res.average_rating),
    best: parseInt(worstToBest[worstToBest.length - 1]),
    numberOfReviews: res.review_count,
    reviews: Utils.parseReviews(res.reviews),
    url,
    worst: parseInt(worstToBest[0]),
  } as TReviews
}
